import React, { Component } from 'react'
import { MenuItem, Checkbox, Grid, Button, TextField, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog } from '@material-ui/core';
import '../../App.css'
import moment from 'moment'
import isEmpty from 'lodash.isempty';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';


const dateFormat = 'DD.MM.YYYY';

export default class UserForm extends Component {
  state = {
    showStartCalendar: false,
    showEndCalendar: false,
    date: new Date(),
    endDate: new Date()
  }

  // titleCase = (str) => {
  //   return str[0].toLowerCase().split(' ').map(function (word) {
  //     return word.replace(word[0], word[0].toUpperCase());
  //   }).join(' ');
  // }


  render() {
    const { dataObj, textInput, handleFieldsChange, createUserFunction, deleteUser, closeDeleteContactDialog, openDeleteDialog } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <div >
        <Grid container spacing={1}
          className={`${Number(access_rights.users) === 1 ? "disableALlFields" : ""}`}>
          <Grid item xs={10}>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Nachname
              </Grid>
              <Grid item xs={9}>
                <TextField
                  inputProps={{
                    maxLength: 60
                  }}
                  helperText={!isEmpty(dataObj.error.lastname) ? dataObj.error.lastname : ''} error={!isEmpty(dataObj.error.lastname) ? true : false}
                  inputRef={textInput}
                  required fullWidth size="small"
                  value={dataObj.nachName}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.lastname))
                      dataObj.error.lastname = []
                    handleFieldsChange(e, "nachname")
                  }} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Vorname
                      </Grid>
              <Grid item xs={9}>
                <TextField
                  inputProps={{
                    maxLength: 60
                  }}
                  required fullWidth size="small"
                  helperText={!isEmpty(dataObj.error.firstname) ? dataObj.error.firstname : ''} error={!isEmpty(dataObj.error.firstname) ? true : false}
                  value={dataObj.vorName}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.firstname))
                      dataObj.error.firstname = []
                    handleFieldsChange(e, "vorname")
                  }} variant="outlined" />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Anrede
              </Grid>
              <Grid item xs={9}>
                <TextField
                  value={dataObj.anrede}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => handleFieldsChange(e, "anrede")}
                >
                  <MenuItem value={'Frau'}>Frau</MenuItem>
                  <MenuItem value={'Herr'}>Herr</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Titel
              </Grid>
              <Grid item xs={9}>
                <TextField
                  inputProps={{
                    maxLength: 20
                  }}
                  helperText={!isEmpty(dataObj.error.title) ? dataObj.error.title : ''} error={!isEmpty(dataObj.error.title) ? true : false}
                  required fullWidth size="small"
                  value={dataObj.title}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.title))
                      dataObj.error.title = []
                    handleFieldsChange(e, "title")
                  }} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                aktiv
                    </Grid>
              <Grid item xs={9}>
                <Checkbox
                  checked={Boolean(dataObj.active)}
                  color="primary"
                  onChange={(e) => handleFieldsChange(e, "active")}
                />
                <span>ja</span>
              </Grid>
            </Grid>
            <Grid container spacing={1} className={dataObj.dateError ? "cl-error" : ''}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Eintritt
              </Grid>
              <Grid item xs={3} className="app-calendar">
                <DatePicker
                  className={!isEmpty(dataObj.error.start_date) ? "errorClass" : ''}
                  locale={locale}
                  value={dataObj.eintritt === "" ? '' : moment(dataObj.eintritt, dateFormat)}
                  format={dateFormat}
                  helperText={!isEmpty(dataObj.error.start_date) || dataObj.startDateError ? dataObj.startDateError ? ['Date Is Invalid (To be transalated in German)'] : dataObj.error.start_date : ''} error={!isEmpty(dataObj.error.start_date) || dataObj.startDateError ? true : false}
                  placeholder="DD.MM.YYYY"
                  bordered={false}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.start_date))
                      dataObj.error.start_date = []
                    handleFieldsChange(e, "eintritt")
                  }} />
              </Grid>
              <Grid item xs={2} style={{ textAlign: 'center', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                Austritt
              </Grid>
              <Grid item xs={3} className="app-calendar">
                <DatePicker
                  locale={locale}
                  value={dataObj.austritt === "" ? '' : moment(dataObj.austritt, dateFormat)}
                  format={dateFormat}
                  helperText={!isEmpty(dataObj.error.start_date) || dataObj.startDateError ? dataObj.startDateError ? ['Date Is Invalid (To be transalated in German)'] : dataObj.error.start_date : ''} error={!isEmpty(dataObj.error.start_date) || dataObj.startDateError ? true : false}
                  placeholder="DD.MM.YYYY"
                  bordered={false}
                  onChange={(e) => handleFieldsChange(e, "austritt")}
                />

              </Grid>
            </Grid>
            {dataObj.error.start_date &&
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                </Grid>
                <Grid className="errorSpan" item xs={9}>
                  <span>
                    {dataObj.error.start_date}
                  </span>
                </Grid>
              </Grid>
            }
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Kürzel
              </Grid>
              <Grid item xs={9}>
                <TextField
                  inputProps={{
                    maxLength: 20
                  }}
                  required fullWidth size="small"
                  helperText={!isEmpty(dataObj.error.loginname) ? dataObj.error.loginname : ''} error={!isEmpty(dataObj.error.loginname) ? true : false}
                  value={dataObj.loginName}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.loginname))
                      dataObj.error.loginname = []
                    handleFieldsChange(e, "loginname")
                  }} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Kategorie
              </Grid>
              <Grid item xs={9}>
                <TextField
                  helperText={!isEmpty(dataObj.error.category_id) ? dataObj.error.category_id : ''} error={!isEmpty(dataObj.error.category_id) ? true : false}
                  value={dataObj.categoryId}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.category_id))
                      dataObj.error.category_id = []
                    handleFieldsChange(e, "category")
                  }} >
                  {dataObj.categoryList &&
                    dataObj.categoryList.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )
                    })
                  }
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Funktion
              </Grid>
              <Grid item xs={9}>
                <TextField
                  value={dataObj.consultentId}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => handleFieldsChange(e, "consultant")} >
                  {dataObj.consultentFunction &&
                    dataObj.consultentFunction.map(func => {
                      return (
                        <MenuItem key={func.id} value={func.id}>{func.name}</MenuItem>
                      )
                    })
                  }
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Land
                    </Grid>
              <Grid item xs={9}>
                <TextField
                  value={dataObj.countryID}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => handleFieldsChange(e, "country")}
                >
                  {dataObj.countryList &&
                    dataObj.countryList.map(country => {
                      return (
                        <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                      )
                    })}
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Straße
                    </Grid>
              <Grid item xs={9}>
                <TextField
                  inputProps={{
                    maxLength: 60
                  }}
                  required fullWidth size="small"
                  value={dataObj.street}
                  onChange={(e) => handleFieldsChange(e, "street")} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                PLZ / Ort
                    </Grid>
              <Grid item xs={3}>
                <TextField required
                  inputProps={{
                    maxLength: 10
                  }}
                  fullWidth size="small"
                  value={dataObj.zipcode}
                  onChange={(e) => handleFieldsChange(e, "zipcode")} variant="outlined" />
              </Grid>
              <Grid item xs={6}>
                <TextField required
                  inputProps={{
                    maxLength: 60
                  }}
                  fullWidth size="small"
                  value={dataObj.city}
                  onChange={(e) => handleFieldsChange(e, "city")} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                eMail
                    </Grid>
              <Grid item xs={9}>
                <TextField required
                  inputProps={{
                    maxLength: 100
                  }}
                  helperText={!isEmpty(dataObj.error.email) ? dataObj.error.email : ''} error={!isEmpty(dataObj.error.email) ? true : false}
                  fullWidth size="small"
                  value={dataObj.mail}
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.email))
                      dataObj.error.email = []
                    handleFieldsChange(e, "mail")
                  }} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                Zustimmung zu Sicherheitsrichtlinie
                      </Grid>
              <Grid item xs={9}>
                <TextField
                  disabled
                  fullWidth size="small"
                  value={dataObj.agreedDate}
                  variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Kennwort
                    </Grid>
              <Grid item xs={9}>
                <TextField required fullWidth size="small"
                  inputProps={{
                    maxLength: 60
                  }}
                  autoComplete="new-password"
                  placeholder={dataObj.editMode ? "*******" : ''}
                  helperText={!isEmpty(dataObj.error.password) ? dataObj.error.password : ''} error={!isEmpty(dataObj.error.password) ? true : false}
                  value={dataObj.password}
                  type='password'
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.password))
                      dataObj.error.password = []
                    handleFieldsChange(e, "password")
                  }} variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                Kennwortbestätigung
                    </Grid>
              <Grid item xs={9}>
                <TextField required fullWidth size="small"
                  inputProps={{
                    maxLength: 60
                  }}
                  placeholder={dataObj.editMode ? "*******" : ''}
                  helperText={!isEmpty(dataObj.error.password_confirmation) ? dataObj.error.password_confirmation : ''} error={!isEmpty(dataObj.error.password_confirmation) ? true : false}
                  value={dataObj.confirmPassword}
                  type="password"
                  onChange={(e) => {
                    if (!isEmpty(dataObj.error.password_confirmation))
                      dataObj.error.password_confirmation = []
                    handleFieldsChange(e, "confirmpass")
                  }} variant="outlined" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <br />
        {Number(access_rights.users) === 2 &&
          <div>
            {
              dataObj.editMode ?
                <div>
                  <Button variant="outlined" color="primary" className="m-10" onClick={createUserFunction} >Speichern</Button>
                  <Button variant="outlined" color="primary" onClick={openDeleteDialog} >Löschen</Button>
                </div>
                :
                <Button variant="outlined" color="primary" className="m-10" onClick={createUserFunction} >Hinzufügen</Button>
            }
          </div>
        }
        <br />
        {dataObj.error.base &&
          <div className="errorSpan">
            <span>{dataObj.error.base[0]}</span>
          </div>
        }
        <Dialog
          open={dataObj.isDeleteContactDialogOpen}
        >
          <DialogTitle>Benutzer löschen</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Sind Sie sicher?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={deleteUser} size="small" variant="outlined" color="primary" autoFocus>
              Bestätigen
              </Button>
            <Button onClick={closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
              Abbrechen
              </Button>
          </DialogActions>
        </Dialog>
      </div >
    )
  }
}
